import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PATH } from '@/utils/constant';
import styles from '@default/default.module.css';

const Error = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(PATH.intro);
  };

  return (
    <div className={styles.center}>
      <h2>{t('not_found_page')}</h2>
      <button className="common" onClick={handleClick}>
        {t('btn_go_main')}
      </button>
    </div>
  );
};

export default Error;
